<template>
  <div class="rose-lega navy darken-2">
    <div
      v-if="showTitle || showFilters"
      :class="[
        showTitle
          ? 'titolo navy--text text--lighten-2 font-hemi-head'
          : 'rose-lega-options-toolbar',
      ]"
    >
      <span v-if="showTitle">Rose Lega</span>
      <v-menu
        v-if="showFilters"
        offset-y
        left
        :close-on-content-click="false"
        min-width="280"
        max-width="320"
        content-class="section-options-menu-content"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            x-small
            rounded
            depressed
            class="section-title-action-btn navy darken-3 navy--text text--lighten-3 px-2"
            title="Opzioni Rose Lega"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon x-small>tune</v-icon>
          </v-btn>
        </template>
        <v-list dense dark class="section-options-menu navy darken-1">
          <v-subheader class="section-options-menu-title">
            Opzioni
          </v-subheader>
          <v-list-item
            dense
            @click="hideInactiveSquadre = !hideInactiveSquadre"
          >
            <v-list-item-action>
              <v-checkbox
                dense
                hide-details
                readonly
                color="secondary"
                :input-value="hideInactiveSquadre"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Nascondi squadre escluse</v-list-item-title>
              <v-list-item-subtitle class="rose-lega-filter-description">
                Nasconde le squadre escluse manualmente dall'amministratore
                d'asta.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showHidePassedSquadreFilter"
            dense
            @click="hidePassedSquadre = !hidePassedSquadre"
          >
            <v-list-item-action>
              <v-checkbox
                dense
                hide-details
                readonly
                color="secondary"
                :input-value="hidePassedSquadre"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Nascondi chi esce dall'asta</v-list-item-title>
              <v-list-item-subtitle class="rose-lega-filter-description">
                Nasconde chi ha premuto PASSO, non può rilanciare, ha completato
                il ruolo o non può partecipare per le regole di lega.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div
      v-show="showTopScrollbar"
      ref="roseLegaScrollTop"
      class="rose-lega-scroll-top nice-scroll"
      @scroll="syncScrollFromTop"
    >
      <div
        class="rose-lega-scroll-spacer"
        :style="{ width: scrollWidth + 'px' }"
      ></div>
    </div>

    <div
      ref="roseLegaHeaderScroll"
      class="rose-lega-header-scroll"
      @scroll="syncScrollFromHeader"
    >
      <div class="rose-lega-scroll-content">
        <div
          v-for="squadraItem in squadre"
          :key="'header_' + squadraItem.id"
          class="rose-lega-squadra"
        >
          <squadra-tavolo
            :id="squadraItem.id"
            class="rose-lega-squadra-summary"
            :size="squadraTavoloSize"
            :disable-menu="disableSquadraMenu"
            :menu-context="squadraMenuContext"
          ></squadra-tavolo>
        </div>
      </div>
    </div>

    <div
      ref="roseLegaScroll"
      class="rose-lega-scroll nice-scroll"
      @scroll="syncScrollFromMain"
    >
      <div ref="roseLegaScrollContent" class="rose-lega-scroll-content">
        <div
          v-for="squadraItem in squadre"
          :key="squadraItem.id"
          class="rose-lega-squadra"
        >
          <div
            v-for="ruolo in ruoli"
            :key="squadraItem.id + '_' + ruolo.ruolo_id"
            class="rose-lega-ruolo"
          >
            <div
              class="rose-lega-ruolo-header"
              :class="'rose-lega-ruolo-' + ruolo.ruolo_id"
              @click="toggleRuolo(ruolo.ruolo_id)"
            >
              <div class="rose-lega-ruolo-main pl-1">
                <span>{{ ruolo.abc }}</span>
                <span class="ruolo-acquisti-label">{{
                  ruoloAcquistiLabel(
                    squadraItem.acquisti[ruolo.ruolo_id] || 0,
                    ruolo
                  )
                }}</span>
              </div>
              <div class="rose-lega-ruolo-dx">

                <span class="rose-lega-ruolo-spesa-relativa">
                  {{
                    percentualeCrediti(
                      squadraItem.spese[ruolo.ruolo_id],
                      squadraItem.budgetEffettivo
                    )
                  }}%
                </span>
                 <span class="rose-lega-ruolo-spesa-assoluta">{{ squadraItem.spese[ruolo.ruolo_id] || 0 }}</span>

                  <v-icon x-small class="white--text rose-lega-chevron">
                  {{
                    isRuoloCollapsed(ruolo.ruolo_id)
                      ? "keyboard_arrow_right"
                      : "keyboard_arrow_down"
                  }}
                </v-icon>
              </div>
            </div>

            <div
              v-if="acquistiInEccesso(maxAcquistiPerRuolo[ruolo.ruolo_id], ruolo)"
              class="rose-lega-eccedenza warning--text"
            >
              <span v-if="acquistiInEccesso(squadraItem.acquisti[ruolo.ruolo_id], ruolo)">
                {{ acquistiInEccesso(squadraItem.acquisti[ruolo.ruolo_id], ruolo) }} in eccesso
              </span>
            </div>

            <div
              v-if="!isRuoloCollapsed(ruolo.ruolo_id)"
              v-for="(slot, index) in squadraItem.rosaPerRuolo[ruolo.ruolo_id]"
              :key="squadraItem.id + '_' + ruolo.ruolo_id + '_' + index"
              class="rose-lega-player"
              :class="{
                empty: !slot || slot.empty,
                'optional-empty': slot && slot.empty && slot.optional,
                ['rose-lega-player-' + ruolo.ruolo_id]: true,
              }"
            >
              <template v-if="slot && !slot.empty">

                <maglia-or-flag-plus-nome :calciatore="slot" />



                <div class="rose-lega-player-name" :title="slot.calciatore">
                  {{ slot.calciatore }}
                </div>

                <main-status
                  v-if="slot.ms"
                  :ms="slot.ms"
                  small
                ></main-status>

                <div class="rose-lega-price">{{ slot.prezzo }}</div>

                <v-menu
                  v-if="canEditCalciatoreAssegnato(slot)"
                  bottom
                  left
                  offset-y
                  content-class="rose-lega-action-menu"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      depressed
                      class="rose-lega-menu-button"
                      color="white"
                      v-on="on"
                      @click.stop
                    >
                      <v-icon small>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense dark class="navy darken-2">
                    <v-list-item
                      @click="editCalciatore(squadraItem.id, slot)"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small>mode_edit</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Modifica costo</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="removeCalciatore(squadraItem.id, slot)"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small>close</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Rimetti svincolato</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import Constants from "../js/constants";
import * as Helpers from "../js/helpers";
import mixins from "../js/mixins";
import SquadraTavolo from "./common/SquadraTavolo";
import MainStatus from "./common/MainStatus";
import MagliaOrFlagPlusNome from "./common/MagliaOrFlagPlusNome";

export default {
  name: "rose-lega",
  mixins: [mixins],
  components: {
    SquadraTavolo,
    MainStatus,
    MagliaOrFlagPlusNome,
  },
  props: {
    showTitle: {
      type: Boolean,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
    disableSquadraMenu: {
      type: Boolean,
      default: false,
    },
    squadraMenuContext: {
      type: String,
      default: Constants.SQUADRA_TAVOLO_MENU_CONTEXT.TAVOLO,
      validator(value) {
        return (
          Object.values(Constants.SQUADRA_TAVOLO_MENU_CONTEXT).indexOf(value) !==
          -1
        );
      },
    },
  },
  data() {
    return {
      ruoliCollapsed: {},
      scrollWidth: 0,
      showTopScrollbar: false,
      hideInactiveSquadre: false,
      hidePassedSquadre: false,
    };
  },
  mounted() {
    console.log("--> RoseLega ready.");
    this.$nextTick(this.updateScrollWidth);
    window.addEventListener("resize", this.updateScrollWidth);
  },
  updated() {
    this.$nextTick(this.updateScrollWidth);
  },
  destroyed() {
    console.log("<-- RoseLega destroyed.");
    window.removeEventListener("resize", this.updateScrollWidth);
  },
  methods: {
    updateScrollWidth() {
      this.scrollWidth = this.$refs.roseLegaScrollContent
        ? this.$refs.roseLegaScrollContent.scrollWidth
        : 0;
      this.showTopScrollbar = this.$refs.roseLegaScroll
        ? this.$refs.roseLegaScroll.scrollWidth >
          this.$refs.roseLegaScroll.clientWidth + 1
        : false;
    },
    syncScrollFromTop() {
      this.syncScrollLeft(this.$refs.roseLegaScrollTop);
    },
    syncScrollFromHeader() {
      this.syncScrollLeft(this.$refs.roseLegaHeaderScroll);
    },
    syncScrollFromMain() {
      this.syncScrollLeft(this.$refs.roseLegaScroll);
    },
    syncScrollLeft(source) {
      if (!source) {
        return;
      }

      const refs = [
        this.$refs.roseLegaScrollTop,
        this.$refs.roseLegaHeaderScroll,
        this.$refs.roseLegaScroll,
      ];

      for (const ref of refs) {
        if (ref && ref !== source) {
          ref.scrollLeft = source.scrollLeft;
        }
      }
    },
    ruoloSetting(ruoloId) {
      const nRuoli = this.asta_info.lega.nRuoli;
      return parseInt(nRuoli[Helpers.ruoloLega(ruoloId)]) || 0;
    },
    calciatoriSquadraPerRuolo(squadra, ruoloId) {
      const ids = Object.keys(squadra.calciatori || {});
      const output = [];
      for (const id of ids) {
        const calciatore = this.calciatori[id];
        if (!calciatore || parseInt(calciatore.ID_Ruolo) !== ruoloId) {
          continue;
        }

        output.push({
          ...calciatore,
          ...squadra.calciatori[id],
          id: id,
          prezzo: squadra.calciatori[id].p || 0,
        });
      }

      return _.orderBy(
        output,
        [
          (calciatore) => parseInt(calciatore.prezzo) || 0,
          (calciatore) => parseInt(calciatore.quotazione) || 0,
          (calciatore) => calciatore.calciatore,
        ],
        ["desc", "desc", "asc"]
      );
    },
    isRuoloCollapsed(ruoloId) {
      return !!this.ruoliCollapsed[ruoloId];
    },
    toggleRuolo(ruoloId) {
      this.$set(this.ruoliCollapsed, ruoloId, !this.isRuoloCollapsed(ruoloId));
      this.$nextTick(this.updateScrollWidth);
    },
    percentualeCrediti(crediti, budgetEffettivo) {
      if (!budgetEffettivo) {
        return 0;
      }

      return Math.round(
        ((parseFloat(crediti) || 0) * 100) / budgetEffettivo
      );
    },
    spesePerRuolo(squadra) {
      const output = {};
      for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
        output[ruolo.ruolo_id] = 0;
      }

      for (const id of Object.keys(squadra.calciatori || {})) {
        const calciatore = this.calciatori[id];
        if (!calciatore) {
          continue;
        }

        const ruoloId = parseInt(calciatore.ID_Ruolo);
        output[ruoloId] =
          (output[ruoloId] || 0) + (parseFloat(squadra.calciatori[id].p) || 0);
      }

      return output;
    },
    spesaTotale(spese) {
      return _.sum(Object.values(spese || {}));
    },
    nRuoliOp() {
      return this.asta_info.lega.nRuoli.op;
    },
    slotPerRuolo(ruoloId) {
      const setting = this.ruoloSetting(ruoloId);
      return Math.max(setting, this.maxAcquistiPerRuolo[ruoloId] || 0);
    },
    requiredSlotPerRuolo(ruoloId) {
      return this.ruoloSetting(ruoloId);
    },
    acquistiInEccesso(acquisti, ruolo) {
      const op = this.nRuoliOp();
      if (op == "=" || op == "<=") {
        return Math.max(0, (acquisti || 0) - ruolo.requiredSlot);
      }
      return 0;
    },
    emptySlot(index, ruolo) {
      return {
        empty: true,
        optional: index >= ruolo.requiredSlot,
      };
    },
    ruoloAcquistiLabel(acquisti, ruolo) {
      const op = this.nRuoliOp();
      if (op == "illimitati") {
        return acquisti + " / ∞";
      }
      if (op == "<=") {
        return acquisti + " / max " + ruolo.requiredSlot;
      }
      if (op == ">=") {
        return  acquisti + " / min " + ruolo.requiredSlot;
      }

      return acquisti + " / " + ruolo.requiredSlot;
    },
    editCalciatore(idSquadra, calciatore) {
      this.promptEditCalciatoreAssegnato(
        idSquadra,
        calciatore.prezzo,
        calciatore.id
      );
    },
    removeCalciatore(idSquadra, calciatore) {
      this.promptRemoveCalciatoreAssegnato(
        calciatore.id,
        idSquadra,
        calciatore.prezzo
      );
    },
    hasSquadraPassato(idSquadra) {
      return (
        this.asta_round &&
        this.asta_round.offerte &&
        this.asta_round.offerte[idSquadra] === Constants.OFFERTA.PASSO
      );
    },
  },
  computed: {
    ruoli() {
      return Object.values(Constants.RUOLI_NEW).map((ruolo) => {
        return {
          ...ruolo,
          slot: this.slotPerRuolo(ruolo.ruolo_id),
          requiredSlot: this.requiredSlotPerRuolo(ruolo.ruolo_id),
        };
      });
    },
    totaleSlotRosa() {
      return _.sumBy(this.ruoli, "slot");
    },
    showHidePassedSquadreFilter() {
      return !this.mode_bustachiusa;
    },
    squadraTavoloSize() {
      return Constants.SQUADRE_SIZE.MEDIUM;
    },
    maxAcquistiPerRuolo() {
      const output = {};
      for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
        output[ruolo.ruolo_id] = 0;
        for (const squadraItem of this.asta_squadre_array) {
          const squadra = this.asta_squadre[squadraItem.id];
          const acquistiRuolo = squadra
            ? this.calciatoriSquadraPerRuolo(squadra, ruolo.ruolo_id).length
            : 0;
          output[ruolo.ruolo_id] = Math.max(output[ruolo.ruolo_id], acquistiRuolo);
        }
      }
      return output;
    },
    astaSquadreArrayConMiaSquadraPrima() {
      if (!this.user_uid || !this.asta_squadre[this.user_uid]) {
        return this.asta_squadre_array;
      }

      const miaSquadraIndex = this.asta_squadre_array.findIndex(
        (squadraItem) => squadraItem.id == this.user_uid
      );

      if (miaSquadraIndex < 0) {
        return this.asta_squadre_array;
      }

      return [
        ...this.asta_squadre_array.slice(miaSquadraIndex),
        ...this.asta_squadre_array.slice(0, miaSquadraIndex),
      ];
    },
    squadre() {
      return this.astaSquadreArrayConMiaSquadraPrima
        .filter((squadraItem) => {
          if (
            this.showFilters &&
            this.hideInactiveSquadre &&
            squadraItem.active !== 1
          ) {
            return false;
          }

          if (
            this.showFilters &&
            this.showHidePassedSquadreFilter &&
            this.hidePassedSquadre &&
            this.hasSquadraPassato(squadraItem.id)
          ) {
            return false;
          }

          return true;
        })
        .map((squadraItem) => {
        const squadra = this.asta_squadre[squadraItem.id];
        const rosaPerRuolo = {};
        const acquisti = {};

        for (const ruolo of this.ruoli) {
          const calciatori = this.calciatoriSquadraPerRuolo(
            squadra,
            ruolo.ruolo_id
          );
          acquisti[ruolo.ruolo_id] = calciatori.length;
          rosaPerRuolo[ruolo.ruolo_id] = calciatori;
          while (rosaPerRuolo[ruolo.ruolo_id].length < ruolo.slot) {
            rosaPerRuolo[ruolo.ruolo_id].push(
              this.emptySlot(rosaPerRuolo[ruolo.ruolo_id].length, ruolo)
            );
          }
        }

        const spese = this.spesePerRuolo(squadra);
        const spesaTotale = this.spesaTotale(spese);

        return {
          id: squadraItem.id,
          name: squadra.name,
          pic: squadra.pic,
          crediti: squadra.crediti,
          acquisti: acquisti,
          spese: spese,
          budgetEffettivo: (parseFloat(squadra.crediti) || 0) + spesaTotale,
          totAcquisti: _.size(squadra.calciatori || {}),
          rosaPerRuolo: rosaPerRuolo,
        };
      });
    },
    ...Vuex.mapGetters([
      "asta_info",
      "asta_squadre",
      "asta_squadre_array",
      "asta_round",
      "calciatori",
      "user_uid",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.rose-lega {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  color: white;
}

.rose-lega-options-toolbar {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 8px 0 4px;
}

// .rose-lega-title {
//   align-items: center;
//   display: flex;
//   gap: 4px;
//   justify-content: center;
//   min-width: 0;
//   padding: 0 0 10px;
//   font-size: 16px;
// }

.rose-lega-scroll {
  overflow: auto;
  min-height: 0;
  flex: 1;
  padding: 4px 0 8px 10px;
}

.rose-lega-scroll-top {
  overflow-x: auto;
  overflow-y: hidden;
}

.rose-lega-scroll,
.rose-lega-scroll-top {
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: var(--v-navy-darken3);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--v-navy-base);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--v-navy-lighten1);
  }
}

.rose-lega-header-scroll {
  flex: 0 0 auto;
  overflow: hidden;
  padding: 8px 0 6px 10px;
}

.rose-lega-scroll-spacer {
  height: 1px;
}

.rose-lega-scroll-content {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}

.rose-lega-squadra {
  flex: 1 0 150px;
  min-width: 155px;
  max-width: 250px;
  padding-top: 2px; // per far vedere crediti spesi e haScelto
}

.rose-lega-ruolo-header,
.rose-lega-player {
  display: flex;
  align-items: center;
}

.rose-lega-squadra-summary {
  width: 100%;
  margin: 0 !important;
}

.rose-lega-squadra-summary::v-deep .content {
  width: 100% !important;
  height: 66px !important;
}

.rose-lega-squadra-summary::v-deep .nome {
  max-width: 78px !important;
  font-size: 11px !important;
  padding-top: 5px;
}

.rose-lega-squadra-summary::v-deep .left-part {
width: 60px !important;
}

.rose-lega-squadra-summary::v-deep .left-part img {
      width: 42px !important;
    border-radius: 99px;
    left: 9px !important;
    bottom: 3px;
    top: inherit;
}

.rose-lega-squadra-summary::v-deep .details {
    align-items: flex-start;
}


.rose-lega-squadra-summary::v-deep .crediti-wrapper {
  font-size: 10px !important;
  gap: 4px;
}

.rose-lega-squadra-summary::v-deep .offerta{
    position: absolute;
    left: 14px;
    top: -4px;
    z-index: 2;
}

.rose-lega-squadra-summary::v-deep .crediti,
.rose-lega-squadra-summary::v-deep .offerta-max {
  // font-size: 10px !important;
}

.rose-lega-ruolo {
  margin-bottom: 8px;
}

.rose-lega-eccedenza {
  min-height: 18px;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 700;
}

.rose-lega-ruolo-header {
  justify-content: space-between;
  height: 20px;
  border-radius: 4px;
  padding: 0 4px;
  margin-bottom: 3px;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
  gap: 3px;
  user-select: none;
}

.rose-lega-ruolo-main,
.rose-lega-ruolo-dx {
  display: flex;
  align-items: center;
  gap:3px;
}

.rose-lega-ruolo-spesa-relativa{
  font-weight: 900;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 0px 5px;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
}

.rose-lega-ruolo-spesa-assoluta{
  font-weight: 900;
  // background-color: rgba(0, 0, 0, 0.2);
  padding: 0px 5px;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
}

.ruolo-acquisti-label{
  // color: rgba(0, 0, 0, 0.4);
  margin-left: 5px;;
}
.rose-lega-ruolo-main {
  gap: 2px;
  min-width: 0;
}

.rose-lega-chevron {
  margin-left: -3px;
}

.rose-lega-ruolo-spesa {
  justify-content: flex-end;
  gap: 3px;
  min-width: 0;
  font-size: 9px;
  white-space: nowrap;
  opacity: 0.9;
}

.rose-lega-ruolo-1 {
  background: var(--ruolo-1);
}
.rose-lega-ruolo-2 {
  background: var(--ruolo-2);
}
.rose-lega-ruolo-3 {
  background: var(--ruolo-3);
}
.rose-lega-ruolo-4 {
  background: var(--ruolo-4);
}

.rose-lega-player {
  height: 24px;
  border-radius: 4px;
  padding: 0 5px;
  margin-bottom: 2px;
  background: rgba(255, 255, 255, 0.08);
  border-left: 3px solid rgba(255, 255, 255, 0.12);
  gap: 4px;
}

.rose-lega-player-1 {
  background: var(--ruolo-1-dark);
  border-left-color: var(--ruolo-1);
}
.rose-lega-player-2 {
  background: var(--ruolo-2-dark);
  border-left-color: var(--ruolo-2);
}
.rose-lega-player-3 {
  background: var(--ruolo-3-dark);
  border-left-color: var(--ruolo-3);
}
.rose-lega-player-4 {
  background: var(--ruolo-4-dark);
  border-left-color: var(--ruolo-4);
}

.rose-lega-player.empty {
  background: rgba(255, 255, 255, 0.035);
  border-left-color: rgba(255, 255, 255, 0.05);
}

.rose-lega-player.optional-empty {
  background: rgba(255, 255, 255, 0.085);
  border-left-color: rgba(255, 255, 255, 0.12);
}

.rose-lega-player-name {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
  text-align: left;
}

.rose-lega-price {
  width: 20px;
  text-align: right;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 700;
}

.rose-lega-menu-button.v-btn.v-size--x-small {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin-right: -4px;
  opacity: 0.85;
}
</style>
